


import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Billing/Calculate.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useFarmerGetMyBillViewQuery } from "../../slices/admin/admin";
import Pagination from "../../Components/Common/Pagination";

const ViewFarmerMyBilling = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const { data, isLoading, isError } = useFarmerGetMyBillViewQuery(id);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [paginatedItems, setPaginatedItems] = useState([]);

  const billData = data?.data?.[0];
  const items = billData?.items || [];

  const totalPages = Math.ceil(items.length / limit) || 1;
  useEffect(() => {
    const startIndex = (currentPage - 1) * limit;
    const endIndex = startIndex + limit;
    setPaginatedItems(items.slice(startIndex, endIndex));
  }, [items, currentPage, limit]);

  const customerName = billData?.storeId?.storeName || "N/A";
  const customerPhone = billData?.storeId?.userId?.phone || "N/A";
  const paymentMethod = billData?.paymentMethod || "N/A";

  const commissionType = billData?.saleCommission || "-";
  const commissionValue = billData?.percentage || 0;
  const commissionAmount = billData?.commissionAmount || 0;
  const handleCharge = billData?.handleCharge || 0;
  const logisticCharge = billData?.logisticCharge || 0;
  const overallTotal = billData?.totalAmount || 0;

  if (isLoading) return <p>Loading...</p>;
  if (isError || !billData) return <p>Error loading bill</p>;

  return (
    <div className={styles.calculateContainer}>
      {/* Header */}
      <div className={styles.header}>
        <h2 className={styles.tittle}>View Billing</h2>
        <span onClick={() => navigate("/dashboard/billing")} className={styles.closeIcon}>
          ✕
        </span>
      </div>

      <div className={styles.padding}>
        {/* Customer Info */}
        {/* <div className={styles.formSection}>
          <div className={styles.inputRow}>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Customer Name</label>
              <input className={styles.input} type="text" value={customerName} disabled />
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Phone Number</label>
              <input className={styles.input} type="text" value={customerPhone} disabled />
            </div>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Payment Type</label>
              <input className={styles.input} type="text" value={paymentMethod} disabled />
            </div>
          </div>
        </div> */}


        <div className={styles.ownerBox}>
          <p><strong>Item Owner :</strong> {customerName}</p>
          <p><strong>Phone No :</strong> {customerPhone}</p>
          <p><strong>Payment Type : </strong> {paymentMethod}</p>
        </div>

        {/* Items Table */}
        <div className={styles.itemsSection}>
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Category</th>
                  {/* <th>Buying Price</th>
                  <th>Selling Price</th> */}
                  <th>Price</th>
                  <th>Qty</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {paginatedItems.map((i) => (
                  <tr key={i._id}>
                    <td>{i.productName || i.itemId?.productName}</td>
                    <td>{i.itemId?.productBag || "-"}</td>
                    {/* <td>₹{i.itemId?.buyingPrice || "-"}</td>
                    <td>₹{i.itemId?.sellingPrice || "-"}</td> */}
                    <td>₹{i.price}</td>
                    <td>{i.itemId?.overallQuantity || i.productQuantity || i.productCount}</td>
                    <td>₹{i.totalPrice}</td>
                  </tr>
                ))}
                {paginatedItems.length === 0 && (
                  <tr>
                    <td colSpan={7} className={styles.noData}>
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {items.length > 0 && (
            <div className={styles.paginationWrapper}>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />

              <select
                className={styles.inputsbtn}
                value={limit}
                onChange={(e) => {
                  setLimit(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value={10}>10 rows</option>
                <option value={25}>25 rows</option>
                <option value={50}>50 rows</option>
              </select>
            </div>
          )}
        </div>

        {/* Charges Section */}
        <div className={styles.chargesSection}>
          <div className={styles.inputRows}>
            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>Commission Type : </label>
              <h2 className={styles.inputones}>{commissionType}</h2>
            </div>

            {commissionType === "percentage" && (
              <div className={styles.inputGroups}>
                <label className={styles.inputLabel}>Enter % : </label>
                <h2 className={styles.inputones}>{commissionValue}%</h2>
              </div>
            )}

            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>Commission Amount : </label>
              <h2 className={styles.inputones}>₹ {commissionAmount}</h2>
            </div>

            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>Handling Charge : </label>
              <h2 className={styles.inputones}>₹ {handleCharge}</h2>
            </div>
          </div>

          <div className={styles.inputRows}>
            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>TransportCharge : </label>
              <h2 className={styles.inputones}>₹ {logisticCharge}</h2>
            </div>
            <div className={styles.inputGroups}>
              <label className={styles.inputLabel}>Overall Total : </label>
              <h2 className={styles.inputones}>₹ {overallTotal}</h2>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className={styles.footerButtons}>
          <button className={styles.cancelBtn} onClick={() => navigate("/dashboard/billing")}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewFarmerMyBilling;

